<template>
        <div class="ordersDiv"  @click="openOrder(order.ID)">
        <div class="orderImg">
            <img :src="order.Data.orderImg" alt="">
        </div>
        
        <div class="ordername"  :key="order.ID" :id="order.ID" :order="order" >
            {{ order.Data.fullname  }} | 
            
            <span class="statusStyle acceptBadge" v-show="order.Data.status == 'התקבלה'">{{ order.Data.status  }} </span>
            <span class="statusStyle readyBadge" v-show="order.Data.status == 'מוכנה'">{{ order.Data.status  }} </span>
            <span class="statusStyle shippedBadge" v-show="order.Data.status == 'נמסרה'">{{ order.Data.status  }} </span>
            <span class="statusStyle canceledBadge" v-show="order.Data.status == 'בוטלה'">{{ order.Data.status  }} </span>
            <span class="statusStyle inprogressBadge" v-show="order.Data.status == 'שלב הכנה'">{{ order.Data.status  }} </span>
            <span class="numberBadge">#{{ order.Data.orderNumber  }} </span>
        </div>
        <div class="orderDetails">
            
            {{ order.Data.phoneNumber }} | {{ order.Data.cakeTaste  + ' ' +  order.Data.cakeSize}} | {{order.Data.dateOrder}} | {{ order.Data.timeOrder }} |  יום {{ order.Data.dayOrder }}  | {{ order.Data.priceOrder }} ₪ 
        </div>
        <div class="addedTime">
            {{ order.Data.createdDate  }} 
             <!-- <router-link  :to="`/SelectedOrderBeta/${order.ID}`">View Order</router-link>  -->
        </div>
    </div>

</template>

<script>
import { db } from '../firebase';
export default{
  name: 'Order',
  props :['order', 'rowIndex'],
  data () {
    return {
        
    }
  },
  
  methods :{

    openOrder(){
        let vm = this;
        console.log("openOrder(" + vm.order.Data.fullname +")..");
        vm.$root.selectedOrderObj = vm.order;
        vm.$root.selectedOrderIndex = vm.rowIndex;
        vm.$router.push("/SelectedOrderBeta/");

        }
    
  }
}
</script>

<style>
.ordersDiv{
    width: 100%;
    height: 110px;
    background-color: #fff;
    padding: 1rem;
    cursor: pointer; 
    border-bottom: 1px solid #eee; 
    position: relative;
}
.ordersDiv:hover{
    background-color: #fcfcfc;

}
.orderImg{
    float: right;
    position: relative;
    margin-left: 15px;
    margin-top: -5px;
}
.orderImg img{
    width: 60px;
    height: 60px;
    border-radius: 8px;
}
.ordername{
    display: block;
    font-size: 15px;
    font-weight: bold;
    color: #313131;
    font-family: 'Noto Sans Hebrew', 'Noto Sans Arabic';
}
.orderDetails{
    margin-top: 5px;
    font-family: 'Noto Sans Hebrew', 'Noto Sans Arabic';
    font-weight: 400;
    font-size: 16px;
    color: #666666;
}
.addedTime{
    position: absolute;
    left: 10px;
    top: 15px;
    color: #666;
    font-size: 14px;
}
.testbadge{
    background-color: blueviolet;
}
.numberBadge{
    padding: 1px 10px;
    background-color: #e0e0e0;
    border-radius: 50px;
    color: #000;
}
.statusStyle{
    padding: 1px 10px;
    border-radius: 50px;
    margin: 0 2px;
    font-size: 14px;
    font-weight: 400;
}
.acceptBadge{
    background-color: #666;
    color: #fff;
}
.readyBadge{
    background-color: #007a4d;
    color: #fff;
}
.shippedBadge{
    background-color: #0265dc;
    color: #fff;
}
.canceledBadge{
    background-color: #d31510;
    color: #fff;
}
.inprogressBadge{
    background-color: #666;
    color: #fff;
}
</style>


// WEBPACK FOOTER //
// src/components/Order.vue